export default __webpack_public_path__ + "static/4-fc7b217cde702a0d99f1de6a794f10d9.jpg";